// PageNavMenuItemRadio
// ***********************************************************************************************************************
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Radio, Stack, Typography } from "@mui/material";
import * as React from "react";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";

export interface IPageNavMenuItemRadioProp {
    classes?: string;
    hidden?: boolean;
    isActive: boolean;
    items: IIdTitle[];
    activeItemId: string;
    title: string;
    onToggleMenuItem: () => void;
    onSetActiveItem: (itemId: string) => void;
}

export class PageNavMenuItemRadio extends React.Component<IPageNavMenuItemRadioProp, {}> {
    handleSetActiveItemId = (itemId: string, checked: boolean) => {
        if (!checked) return;
        this.props.onSetActiveItem(itemId);
    };
    
    render() {
        const props = this.props;
        if (props.hidden) return null;
        const items = props.items;
        return (
            <>
                <Accordion expanded={props.isActive}>
                    <AccordionSummary onClick={props.onToggleMenuItem} expandIcon={<ExpandMoreIcon />}>
                        {props.title}
                    </AccordionSummary>
                    <AccordionDetails>
                        {items &&
                            <Stack>
                                {items.map((item) => {
                                    const isActiveItem = props.activeItemId === item.id;
                                    return <FormControlLabel
                                        key={item.id}
                                        label={item.title}
                                        control={
                                            <Radio checked={isActiveItem} />
                                        }
                                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleSetActiveItemId(item.id, true); }}
                                    />;
                                })}
                            </Stack>
                        }
                    </AccordionDetails>
                </Accordion>
                {!props.isActive && (
                    <Stack sx={{ margin: ".5rem" }}>
                        {items.filter(x => props.activeItemId === x.id).map((item) => (
                            <Typography key={item.id}>{item.title}</Typography>
                        ))}
                    </Stack>
                )}
            </>
        );
    }
}